import {
  EQAllowedGains,
  EQAllowedFrequencies,
} from "shared/games/mixpuzzles/types";

export const barSettings = {
  eqLine: {},
  bars: [
    {
      barClassName: "fill-purple-900",
      textClassName: "fill-purple-400",
      barSplitLineClassName: "stroke-purple-700",
      fill: "purple",
      text: "Bass",
      freq: "40-180Hz",
    },
    {
      barClassName: "fill-purple-700",
      textClassName: "fill-purple-300",
      barSplitLineClassName: "stroke-purple-500",
      fill: "blue",
      text: "Low Mids",
      freq: "180-600hz",
    },
    {
      barClassName: "fill-purple-500",
      textClassName: "fill-purple-200",
      barSplitLineClassName: "stroke-purple-300",
      fill: "teal",
      text: "High Mids",
      freq: "600-3khz",
    },
    {
      barClassName: "fill-purple-300",
      textClassName: "fill-purple-500",
      barSplitLineClassName: "stroke-purple-500",
      fill: "orange",
      text: "High",
      freq: "3-14khz",
    },
  ],
};

export const freqCount = 4;
export const gainCount = 2;
export const defaultNormalizedEQGain = 1;
export const normalizedEQGainLookUp = new Map<number, EQAllowedGains>([
  [0, 10],
  [defaultNormalizedEQGain, 0],
]);
export const reversedNormalizedEQGainLookUp = new Map<EQAllowedGains, number>([
  [10, 0],
  [0, 1],
]);

export const normalizedEQFreqLookup = new Map<number, EQAllowedFrequencies>([
  [0, "bass"],
  [1, "lmid"],
  [2, "hmid"],
  [3, "high"],
]);
export const reversedNormalizedEQFreqLookup = new Map<
  EQAllowedFrequencies,
  number
>([
  ["bass", 0],
  ["lmid", 1],
  ["hmid", 2],
  ["high", 3],
]);
export const defaultNormalizedEQFreq = 0;

// sanity check errors
if (normalizedEQGainLookUp.size !== gainCount) {
  throw new Error("The lookup table must mirror the number of gain bands");
}

if (normalizedEQFreqLookup.size !== freqCount) {
  throw new Error("The lookup table must mirror the number of freq bands");
}
